/**
 * Departamentos de Colombia + Bogotá D.C. — modo "Red nacional CALE".
 *
 * [EVIDENCIA] Códigos DIVIPOLA oficiales DANE. Regiones según agrupación
 * analítica usada en la investigación del proyecto (DANE/RAP).
 * Coordenadas: centroides aproximados [DISEÑO] para visualización 3D,
 * NO son centroides geodésicos oficiales.
 */
export const FUENTE_DEPARTAMENTOS = "DANE — DIVIPOLA (enero 2024)";
export const FECHA_CORTE_DEPARTAMENTOS = "2026-09-27";

export type RegionColombia = "Andina" | "Caribe" | "Pacífica" | "Orinoquía" | "Amazonía";

export interface Departamento {
  /** Código DIVIPOLA del departamento (2 dígitos). */
  codigoDivipola: string;
  nombre: string;
  region: RegionColombia;
  /** Centroide aproximado [DISEÑO] — solo para ubicación en escena 3D. */
  lat: number;
  lon: number;
}

export const DEPARTAMENTOS: readonly Departamento[] = [
  { codigoDivipola: "05", nombre: "Antioquia", region: "Andina", lat: 6.55, lon: -75.7 },
  { codigoDivipola: "08", nombre: "Atlántico", region: "Caribe", lat: 10.8, lon: -74.9 },
  { codigoDivipola: "11", nombre: "Bogotá, D.C.", region: "Andina", lat: 4.71, lon: -74.07 },
  { codigoDivipola: "13", nombre: "Bolívar", region: "Caribe", lat: 9.2, lon: -74.8 },
  { codigoDivipola: "15", nombre: "Boyacá", region: "Andina", lat: 5.8, lon: -73.1 },
  { codigoDivipola: "17", nombre: "Caldas", region: "Andina", lat: 5.2, lon: -75.4 },
  { codigoDivipola: "18", nombre: "Caquetá", region: "Amazonía", lat: 1.6, lon: -75.6 },
  { codigoDivipola: "19", nombre: "Cauca", region: "Pacífica", lat: 2.5, lon: -76.7 },
  { codigoDivipola: "20", nombre: "Cesar", region: "Caribe", lat: 9.6, lon: -73.4 },
  { codigoDivipola: "23", nombre: "Córdoba", region: "Caribe", lat: 8.4, lon: -75.8 },
  { codigoDivipola: "25", nombre: "Cundinamarca", region: "Andina", lat: 4.9, lon: -74.4 },
  { codigoDivipola: "27", nombre: "Chocó", region: "Pacífica", lat: 5.7, lon: -76.7 },
  { codigoDivipola: "41", nombre: "Huila", region: "Andina", lat: 2.8, lon: -75.4 },
  { codigoDivipola: "44", nombre: "La Guajira", region: "Caribe", lat: 11.4, lon: -72.5 },
  { codigoDivipola: "47", nombre: "Magdalena", region: "Caribe", lat: 10.4, lon: -74.1 },
  { codigoDivipola: "50", nombre: "Meta", region: "Orinoquía", lat: 3.7, lon: -73.1 },
  { codigoDivipola: "52", nombre: "Nariño", region: "Andina", lat: 1.2, lon: -77.3 },
  { codigoDivipola: "54", nombre: "Norte de Santander", region: "Andina", lat: 7.9, lon: -72.9 },
  { codigoDivipola: "63", nombre: "Quindío", region: "Andina", lat: 4.5, lon: -75.7 },
  { codigoDivipola: "66", nombre: "Risaralda", region: "Andina", lat: 5.1, lon: -75.8 },
  { codigoDivipola: "68", nombre: "Santander", region: "Andina", lat: 6.9, lon: -73.2 },
  { codigoDivipola: "70", nombre: "Sucre", region: "Caribe", lat: 9.3, lon: -75.4 },
  { codigoDivipola: "73", nombre: "Tolima", region: "Andina", lat: 4.2, lon: -75.1 },
  { codigoDivipola: "76", nombre: "Valle del Cauca", region: "Pacífica", lat: 3.8, lon: -76.3 },
  { codigoDivipola: "81", nombre: "Arauca", region: "Orinoquía", lat: 7.0, lon: -71.4 },
  { codigoDivipola: "85", nombre: "Casanare", region: "Orinoquía", lat: 5.6, lon: -71.8 },
  { codigoDivipola: "86", nombre: "Putumayo", region: "Amazonía", lat: 0.8, lon: -76.2 },
  { codigoDivipola: "88", nombre: "Archipiélago de San Andrés, Providencia y Santa Catalina", region: "Caribe", lat: 12.6, lon: -81.7 },
  { codigoDivipola: "91", nombre: "Amazonas", region: "Amazonía", lat: -1.5, lon: -71.5 },
  { codigoDivipola: "94", nombre: "Guainía", region: "Amazonía", lat: 2.7, lon: -68.3 },
  { codigoDivipola: "95", nombre: "Guaviare", region: "Amazonía", lat: 2.0, lon: -72.3 },
  { codigoDivipola: "97", nombre: "Vaupés", region: "Amazonía", lat: 0.9, lon: -70.3 },
  { codigoDivipola: "99", nombre: "Vichada", region: "Orinoquía", lat: 5.1, lon: -68.7 },
] as const;
